'use client'

import { IProduct } from '@/app/[locale]/_types'
import ProductCard from '../../Card'
import { Button } from '@/components/ui/button'
import { usePathname, useRouter } from '@/i18n/navigation'
import { Center, SimpleGrid, Text } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import useProductDiscount from '@/app/[locale]/_hooks/useProductDiscount'

const Filtered = ({
  products,
}: {
  products: { products: IProduct[]; count: number | string }
}) => {
  const t = useTranslations()
  const router = useRouter()
  const pathname = usePathname()
  const { discounts } = useProductDiscount()

  const handleClearFilter = () => {
    if (pathname.startsWith('/landing-menu')) {
      router.push('/landing-menu')
    } else {
      router.push('/')
    }
  }

  if (products?.products?.length > 0) {
    return (
      <>
        <Text
          lineHeight={1}
          fontSize={{ base: 'xl', lg: '4xl' }}
          fontWeight={700}
          mt={{
            base: 4,
            lg: 8,
          }}
          mb={4}
        >
          {t('result_filter')}
        </Text>
        <SimpleGrid
          gapX={{ base: 3, lg: 6 }}
          gapY={{ base: 3, lg: 4 }}
          columns={{ base: 2, lg: 4 }}
        >
          {products?.products?.map((el) => (
            <ProductCard
              categoryName=''
              discounts={discounts}
              key={el.id}
              product={el}
            />
          ))}
        </SimpleGrid>
      </>
    )
  }

  return (
    <Center
      justifyContent={'center'}
      alignItems={'center'}
      flexDir={'column'}
      textAlign={'center'}
      h={'50dvh'}
      gap={2}
    >
      <Text fontWeight={700} fontSize={25}>
        {t('nothing_filter')}
      </Text>
      <Text color={'gray.500'} fontSize={'sm'}>
        {t('search_not_found_text')}
      </Text>
      <Button
        mt={3}
        fontWeight={500}
        w={'fit-content'}
        py={'10px'}
        px={6}
        variant={'solid'}
        bg='primary'
        color='primary.text'
        _hover={{ bg: 'primary.hover' }}
        rounded={16}
        onClick={handleClearFilter}
      >
        {t('reset_filter')}
      </Button>
    </Center>
  )
}

export default Filtered
